import Intercom from '@intercom/messenger-js-sdk';

import { session } from '@/globals//session';
import { i18n } from '@/i18n/i18n';


function isEnabled() {
  return (
    session.account &&
    session.account.role == 'admin' &&
    session.institution &&
    session.institution.brand == 'zeitstrom'
  );
}

function isIntercomLoaded() {
  return typeof window.Intercom === 'function';
}

function load() {
  if (isIntercomLoaded()) return;

  Intercom({
    app_id: 'w7h8y7gn',
    user_id: session.account.id,
    name: session.account.full_name,
    email: session.account.email,

    company: {
      company_id: session.institution.id,
      created_at: Math.floor(new Date(session.institution.created_at).getTime()),
      name: session.institution.name,
      plan: session.institution.plan,
      website: 'https://app.zeit.work/staff/institutions/?q=' + session.institution.name,
    },


    created_at: Math.floor(new Date(session.account.created_at).getTime()),
    language_override: i18n.global.locale,
    hide_default_launcher: true,
  });
  console.log('Intercom loaded');

}

function shutdown() {
  if (!isIntercomLoaded()) return;

  if (window.Intercom === undefined) return;
  window.Intercom('shutdown');
  window.Intercom = undefined;
}

function handleIntercomVisibility() {
  if (isEnabled()) load(); else shutdown();
}

export function showIntercom() {
  if (!isIntercomLoaded()) {
    console.log('Intercom not loaded, skipping show()');
    return;
  }

  console.log('Showing Intercom');
  window.Intercom('show');
}

export function showIntercomWithProductTour(productTourId: string) {
  if (!isIntercomLoaded()) {
    console.log('Intercom not loaded, skipping show()');
    return;
  }

  console.log('Showing Intercom with product tour ' + productTourId);
  setTimeout(() => window.Intercom('startTour', productTourId), 1000);
}

export function initIntercom() {
  handleIntercomVisibility();
  session.on('change', handleIntercomVisibility);
  session.on('reset', shutdown);
}